// _translate :: forall a. Fn2 String a String
exports._translate = function(key, data) {
  return I18n.translate(key, data);
};

// _interpolate :: forall a. Fn2 String a String
exports._interpolate = function(message, data) {
  return I18n.interpolate(message, data);
};

// _translateIn :: forall a. Fn3 String String a String
exports._translateIn = function(locale, key, data) {
  var dataWithLocale = Object.create(data);
  dataWithLocale.locale = locale;
  return I18n.translate(key, dataWithLocale);
};

// _getGlobalLocale :: Effect String
exports._getGlobalLocale = function() {
  return I18n.locale;
};

// _setGlobalLocale :: EffectFn1 () String Unit
exports._setGlobalLocale = function(locale) {
  I18n.locale = locale;
};

// _getGlobalDefaultLocale :: Effect String
exports._getGlobalDefaultLocale = function() {
  return I18n.defaultLocale;
};
